import React, { DetailedHTMLProps } from 'react'
import CardUi from '@components/ui/Card/CardUi'
import styles from './TopUsers.module.scss'
import { Empty, Spin } from 'antd'
import cn from 'classnames'
import { ITopCardData } from '@dto/mainStat/mainStat.dto'
import { IconCheckCircle, IconRadiation } from '@utils/icons'

interface Props extends DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  users: ITopCardData[]
  title: string
  active?: boolean
  isLoading?: boolean
  userLink?: (id: string) => void
  crmLink?: (id: string, name: string) => void
}

export const antIcon = <IconRadiation width='33' height='33' fill='var(--color-main)' />

const TopUsers: React.FC<Props> = ({
  users,
  title,
  active = false,
  isLoading = false,
  userLink,
  crmLink,
  ...props
}) => {
  return (
    <CardUi {...props} className={styles.topContainer}>
      <>
        <div className={cn(styles.title, { [styles.active]: active })}>
          {title}
          {active && (
            <span>
              <IconCheckCircle width='22' height='22' fill='var(--color-green)' />
            </span>
          )}
        </div>
        {users && users.length ? (
          <div className={styles.list}>
            <div className={styles.rowHeader}>
              {['Менеджер', 'CRM', 'Кол-во'].map((el) => (
                <span className={styles.headerItem} key={el + title}>
                  {el}
                </span>
              ))}
            </div>
            {users.map((item) => (
              <div className={styles.row} key={item.userid + title}>
                <span
                  className={styles.userName}
                  onClick={() => {
                    userLink && userLink(item.userid)
                  }}
                >
                  {item.nick_name}
                </span>
                <span
                  className={styles.crmName}
                  onClick={() => {
                    crmLink && crmLink(item.crmid, item?.crmname)
                  }}
                >
                  {item.crmname}
                </span>
                <span className={styles.count}>{item.daycalls}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.spin}>
            {isLoading ? (
              <Spin indicator={antIcon} className={styles.loadSpin} />
            ) : (
              <Empty description='Нет данных' />
            )}
          </div>
        )}
      </>
    </CardUi>
  )
}

export default TopUsers
